<template>
  <div id="page-start" class="container-fluid">
    <alert :value="alertBox"></alert>
    <loading v-if="!pageLoaded"></loading>
    <div class="row">
      <div class="es-xs-12 es-sm-7 u-margin-top-xsmall">
        <div v-if="pageLoaded" class="u-radius-g">
          <h5
            class="u-cursor-pointer u-padding-xxsmall u-display-flex u-align-items-center u-justify-content-space-between"
            @click="toggleSection('series')"
          >
            <div class="u-display-inline-flex u-align-items-center">
              <span
                class="u-margin-right-xsmall u-circle u-circle__variant--small"
                :class="`u-circle__variant--${sectionSeries.variant}`"
              >
                <i :class="`icofont-${sectionSeries.icon}`"></i>
              </span>
              <div>
                <div>
                  {{ $t("cyclesForm.series") }}
                  <span
                    class="u-margin-left-xsmall u-color-muted u-display-inline-block"
                    >({{ sectionSeries.active }} /
                    {{ sectionSeries.total }})</span
                  >
                </div>
              </div>
            </div>
            <i
              :class="`icofont-rounded-${
                activeSections.includes('series') ? 'up' : 'down'
              }`"
            ></i>
          </h5>
          <div
            class="u-padding-xxsmall"
            v-if="activeSections.includes('series')"
          >
            <div>
              <SeriesSearch
                v-model="series"
                class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child c-form-control__variant--xs"
                :label="$t('cyclesForm.series')"
                :validActivated="validActivated"
              />
            </div>
            <div>
              <MainProjectSearch
                :disabled="!series"
                class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child c-form-control__variant--xs"
                :validActivated="validActivated"
                :label="$t('cyclesForm.mainProject')"
                v-model="mainProject"
                :query="{ seriesId: series?.id }"
              />
            </div>
            <div>
              <ProjectMainProjectSearch
                class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child c-form-control__variant--xs"
                v-model="projectMainProject"
                :query="{ mainProjectId: mainProject?.id }"
                :validActivated="validActivated"
                :disabled="!mainProject"
                :label="$t('cyclesForm.project')"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="es-xs-12 es-sm-5 u-margin-top-xsmall">
        <div v-if="project" class="u-radius-g">
          <h6
            class="u-cursor-pointer u-padding-xxsmall u-display-flex u-align-items-center u-justify-content-space-between"
            @click="toggleSection('refrigerantTemperature')"
          >
            <div class="u-display-inline-flex u-align-items-center">
              <span
                class="u-margin-right-xsmall u-circle u-circle__variant--small"
                :class="`u-circle__variant--${sectionRefrigerant.variant}`"
              >
                <i :class="`icofont-${sectionRefrigerant.icon}`"></i>
              </span>
              <div>
                <div>
                  {{ $t("cyclesForm.refrigerantTemperature") }}
                  <span
                    class="u-margin-left-xsmall u-color-muted u-display-inline-block"
                    >({{ sectionRefrigerant.active }} /
                    {{ sectionRefrigerant.total }})</span
                  >
                </div>
              </div>
            </div>
            <i
              :class="`icofont-rounded-${
                activeSections.includes('refrigerantTemperature')
                  ? 'up'
                  : 'down'
              }`"
            ></i>
          </h6>
          <div
            class="u-padding-xxsmall"
            v-if="activeSections.includes('refrigerantTemperature')"
          >
            <div class="">
              <RefrigerantSearch
                v-model="refrigerant"
                class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child c-form-control__variant--xs"
                :validActivated="validActivated"
                :label="$t('cyclesForm.refrigerant')"
              />
            </div>
            <div class="">
              <BaseInput
                size="xs"
                type="number"
                class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
                :placeholder="
                  $t('common.enterPlaceholder', {
                    label: $t('cyclesForm.superheat'),
                  })
                "
                block
                v-model="form.superheat"
                :label="$t('cyclesForm.superheat')"
                :mandotary="validActivated"
              />
            </div>
            <div class="">
              <BaseInput
                size="xs"
                type="number"
                class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
                block
                v-model="form.subcooling"
                :placeholder="
                  $t('common.enterPlaceholder', {
                    label: $t('cyclesForm.subcooling'),
                  })
                "
                :label="$t('cyclesForm.subcooling')"
                :mandotary="validActivated"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="es-xs-12 es-sm-7 u-margin-top-xsmall">
        <div v-if="project" class="u-radius-g">
          <h6
            class="u-cursor-pointer u-padding-xxsmall u-display-flex u-align-items-center u-justify-content-space-between"
            @click="toggleSection('equipments')"
          >
            <div class="u-display-inline-flex u-align-items-center">
              <span
                class="u-margin-right-xsmall u-circle u-circle__variant--small"
                :class="`u-circle__variant--${sectionEquipments.variant}`"
              >
                <i :class="`icofont-${sectionEquipments.icon}`"></i>
              </span>
              <div>
                <div>
                  {{ $t("cyclesForm.equipments") }}
                  <span
                    class="u-margin-left-xsmall u-color-muted u-display-inline-block"
                    >({{ sectionEquipments.active }} /
                    {{ sectionEquipments.total }})</span
                  >
                </div>
              </div>
            </div>
            <i
              :class="`icofont-rounded-${
                activeSections.includes('equipments') ? 'up' : 'down'
              }`"
            ></i>
          </h6>
          <div
            class="u-padding-xxsmall"
            v-if="activeSections.includes('equipments')"
          >
            <div class="">
              <BatterySearch
                v-model="evaporator"
                class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child c-form-control__variant--xs"
                :type="BatteryType.Evaporator"
                :label="$t('cyclesForm.evaporator')"
                :validActivated="validActivated"
              />
            </div>
            <div class="">
              <GeneralStaticSearch
                v-model="evaporatorQuantity"
                class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child c-form-control__variant--xs"
                :items="evaporatorQuantityList"
                :label="$t('cyclesForm.evaporatorQuantity')"
                optionField="label"
                :validActivated="validActivated"
              />
            </div>
            <div class="">
              <BatterySearch
                v-model="condenser"
                class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child c-form-control__variant--xs"
                :type="BatteryType.Condenser"
                :label="$t('cyclesForm.condenser')"
                :validActivated="validActivated"
              />
            </div>
            <div class="">
              <GeneralStaticSearch
                v-model="condenserQuantity"
                class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child c-form-control__variant--xs"
                :items="condenserQuantityList"
                :label="$t('cyclesForm.condenserQuantity')"
                optionField="label"
                :validActivated="validActivated"
              />
            </div>
            <div class="">
              <CompressorBrandSearch
                v-model="compressorBrand"
                class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child c-form-control__variant--xs"
                :label="$t('cyclesForm.compressorBrand')"
                :validActivated="validActivated"
              />
            </div>
            <div class="">
              <CompressorRefrigerantSearch
                v-model="compressorRefrigerant"
                class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child c-form-control__variant--xs"
                :query="{ brandId: compressorBrand?.id }"
                :label="$t('cyclesForm.compressorRefrigerant')"
                :disabled="!compressorBrand"
                :validActivated="validActivated"
              />
            </div>
            <div class="">
              <CompressorRefrigerantModelSearch
                v-model="compressorRefrigerantModel"
                class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child c-form-control__variant--xs"
                :query="{ brandRefrigerantId: compressorRefrigerant?.id }"
                :disabled="!compressorRefrigerant"
                :label="$t('cyclesForm.compressorRefrigerantModel')"
                :validActivated="validActivated"
              />
            </div>
            <div class="">
              <GeneralStaticSearch
                v-model="compressorQuantity"
                class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child c-form-control__variant--xs"
                :items="compressorQuantityList"
                :label="$t('cyclesForm.compressorQuantity')"
                optionField="label"
                :validActivated="validActivated"
              />
            </div>
          </div>
        </div>
        <div v-if="project" class="u-radius-g u-margin-top-xsmall">
          <div class="u-padding-xxsmall">
            <div
              class="u-color-primary u-display-block-sm-down u-margin-top-small-sm-down"
            >
              <small> {{ $t("cyclesForm.evapAbsoluteFlowDifference") }}:</small>
              {{ mutlakDebi.evapAbsoluteFlowDifference }}

              <small>{{ $t("cyclesForm.condAbsoluteFlowDifference") }}:</small>
              {{ mutlakDebi.condAbsoluteFlowDifference }}
            </div>
          </div>
        </div>
      </div>
      <div class="es-xs-12 es-sm-5 u-margin-top-xsmall">
        <div v-if="project" class="u-radius-g">
          <h6
            class="u-cursor-pointer u-padding-xxsmall u-display-flex u-align-items-center u-justify-content-space-between"
            @click="toggleSection('airSideFeatures')"
          >
            <div class="u-display-inline-flex u-align-items-center">
              <span
                class="u-margin-right-xsmall u-circle u-circle__variant--small"
                :class="`u-circle__variant--${sectionAirSideFeatures.variant}`"
              >
                <i :class="`icofont-${sectionAirSideFeatures.icon}`"></i>
              </span>
              <div>
                <div>
                  {{ $t("cyclesForm.airSideFeatures") }}
                  <span
                    class="u-margin-left-xsmall u-color-muted u-display-inline-block"
                    >({{ sectionAirSideFeatures.active }} /
                    {{ sectionAirSideFeatures.total }})</span
                  >
                </div>
              </div>
            </div>
            <i
              :class="`icofont-rounded-${
                activeSections.includes('airSideFeatures') ? 'up' : 'down'
              }`"
            ></i>
          </h6>
          <div
            class="u-padding-xxsmall"
            v-if="activeSections.includes('airSideFeatures')"
          >
            <div
              class="u-display-flex u-align-items-center u-margin-bottom-small"
            >
              <Checkbox
                :value="form.constantAirFlowRate"
                @change="updateFlowRate('constantAirFlowRate', $event)"
                :label="$t('cyclesForm.constantAirFlowRate')"
              />
              <Checkbox
                class="u-margin-left-small"
                :value="form.variableAirFlowRate"
                @change="updateFlowRate('variableAirFlowRate', $event)"
                :label="$t('cyclesForm.variableAirFlowRate')"
              />
            </div>
            <div class="">
              <BaseInput
                size="xs"
                block
                :readonly="form.constantAirFlowRate"
                class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
                type="number"
                v-model="form.condensingTemp"
                :mandotary="validActivated"
                suffix="C"
                :label="$t('cyclesForm.condensingTemp')"
                :placeholder="
                  $t('common.enterPlaceholder', {
                    label: $t('cyclesForm.condensingTemp'),
                  })
                "
              />
            </div>
            <div class="">
              <BaseInput
                size="xs"
                :readonly="form.variableAirFlowRate"
                block
                suffix="m3/h"
                class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
                type="number"
                v-model="form.condenserFanFlow"
                :mandotary="validActivated"
                :label="$t('cyclesForm.condenserFanFlow')"
                :placeholder="
                  $t('common.enterPlaceholder', {
                    label: $t('cyclesForm.condenserFanFlow'),
                  })
                "
              />
            </div>
            <div class="">
              <BaseInput
                size="xs"
                block
                type="number"
                class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
                suffix="C"
                v-model="form.condenserAirInletTemp"
                :mandotary="validActivated"
                :label="$t('cyclesForm.condenserAirInletTemp')"
                :placeholder="
                  $t('common.enterPlaceholder', {
                    label: $t('cyclesForm.condenserAirInletTemp'),
                  })
                "
              />
            </div>
            <div class="">
              <BaseInput
                size="xs"
                block
                class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
                type="number"
                suffix="%"
                v-model="form.condenserAirInletHumidity"
                :mandotary="validActivated"
                :label="$t('cyclesForm.condenserAirInletHumidity')"
                :placeholder="
                  $t('common.enterPlaceholder', {
                    label: $t('cyclesForm.condenserAirInletHumidity'),
                  })
                "
              />
            </div>
            <div class="">
              <BaseInput
                size="xs"
                block
                class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
                type="number"
                v-model="form.evaporatorFanFlow"
                suffix="m3/h"
                :mandotary="validActivated"
                :label="$t('cyclesForm.evaporatorFanFlow')"
                :placeholder="
                  $t('common.enterPlaceholder', {
                    label: $t('cyclesForm.evaporatorFanFlow'),
                  })
                "
              />
            </div>

            <div class="">
              <BaseInput
                size="xs"
                block
                type="number"
                suffix="C"
                class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
                v-model="form.evaporatorAirInletTemp"
                :mandotary="validActivated"
                :label="$t('cyclesForm.evaporatorAirInletTemp')"
                :placeholder="
                  $t('common.enterPlaceholder', {
                    label: $t('cyclesForm.evaporatorAirInletTemp'),
                  })
                "
              />
            </div>
            <div class="">
              <BaseInput
                size="xs"
                suffix="%"
                class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
                block
                type="number"
                v-model="form.evaporatorAirInletHumidity"
                :mandotary="validActivated"
                :label="$t('cyclesForm.evaporatorAirInletHumidity')"
                :placeholder="
                  $t('common.enterPlaceholder', {
                    label: $t('cyclesForm.evaporatorAirInletHumidity'),
                  })
                "
              />
            </div>
          </div>
        </div>
        <div
          v-if="project"
          class="u-radius-g u-padding-xxsmall u-margin-top-xsmall"
        >
          <Button block @click="getResult" variant="secondary">
            <i class="icofont-check"></i> {{ $t("cyclesForm.calculate") }}
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SeriesSearch from "../../Searches/SeriesSearch.vue";
import MainProjectSearch from "@/components/Searches/MainProjectSearch.vue";
import ProjectMainProjectSearch from "@/components/Searches/ProjectMainProjectSearch.vue";
import RefrigerantSearch from "@/components/Searches/RefrigerantSearch.vue";
import BatterySearch from "@/components/Searches/BatterySearch.vue";
import CompressorBrandSearch from "@/components/Searches/CompressorBrandSearch.vue";
import CompressorRefrigerantSearch from "@/components/Searches/CompressorRefrigerantSearch.vue";
import CompressorRefrigerantModelSearch from "@/components/Searches/CompressorRefrigerantModelSearch.vue";
import BaseInput from "@/components/Base/Inputs/BaseInput.vue";
import GeneralStaticSearch from "@/components/Searches/GeneralStaticSearch.vue";
import { BatteryType } from "@/enums/Battery/BatteryType";
import Button from "@/components/Base/Button.vue";
import Checkbox from "@/components/Base/Inputs/Checkbox.vue";
import Requests from "@/services/Requests";
import Alert from "@/components/Base/Alert.vue";
export default {
  components: {
    SeriesSearch,
    MainProjectSearch,
    ProjectMainProjectSearch,
    RefrigerantSearch,
    BatterySearch,
    CompressorBrandSearch,
    CompressorRefrigerantSearch,
    BaseInput,
    CompressorRefrigerantModelSearch,
    GeneralStaticSearch,
    Button,
    Checkbox,
    Alert,
  },
  data() {
    return {
      mutlakDebi: {
        evapAbsoluteFlowDifference: 1,
        condAbsoluteFlowDifference: 1,
      },
      pageLoaded: false,
      alertBox: { status: false, variant: null, text: null },
      validActivated: false,
      evaporatorQuantityList: [1, 2, 3, 4],
      condenserQuantityList: [1, 2],
      compressorQuantityList: [1, 2],
      activeSections: [
        "series",
        "refrigerantTemperature",
        "equipments",
        "airSideFeatures",
      ],
      BatteryType,
      series: null,
      mainProject: null,
      projectMainProject: null,
      project: null,
      refrigerant: null,
      evaporator: null,
      evaporatorQuantity: { label: 1 },
      condenser: null,
      condenserQuantity: null,
      compressorBrand: null,
      compressorRefrigerant: null,
      compressorRefrigerantModel: null,
      compressorQuantity: null,
      form: {
        superheat: null,
        subcooling: null,
        condensingTemp: null,
        condenserFanFlow: null,
        condenserAirInletTemp: null,
        condenserAirInletHumidity: null,
        evaporatorFanFlow: null,
        evaporatorAirInletTemp: null,
        evaporatorAirInletHumidity: null,
        constantAirFlowRate: false,
        variableAirFlowRate: false,
      },
    };
  },
  watch: {
    async projectMainProject(value) {
      if (value) {
        this.project = await this.GET_PROJECT_BY_ID(value.project.id);
        this.updateSectionsAfterUpdateProject(this.project);
      }
    },
    async project(value) {
      if (value) {
        this.updateSectionsAfterUpdateProject(value);
      }
    },
    async evaporator(value, oldValue) {
      if (value) {
        this.form.evaporatorAirInletHumidity =
          value.refrigerantFeatures.airInletHumidity;
        this.form.evaporatorAirInletTemp =
          value.refrigerantFeatures.airInletTemp;

        if (oldValue) {
          this.form.evaporatorFanFlow = value.refrigerantFeatures.fanFlow;
        }
      }
    },
    async condenser(value, oldValue) {
      if (value) {
        this.form.condenserAirInletHumidity =
          value.refrigerantFeatures.airInletHumidity;
        this.form.condenserAirInletTemp =
          value.refrigerantFeatures.airInletTemp;
        this.form.condensingTemp = value.refrigerantFeatures.condenserTemp;

        if (oldValue) {
          this.form.condenserFanFlow = value.refrigerantFeatures.fanFlow;
        }
      }
    },
    refrigerant(value) {
      if (value) {
        this.$emit("update:refrigerant", value.id);
      }
    },
  },
  props: {
    initCycle: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    sectionSeries() {
      let active = 0;
      if (this.series) {
        active++;
      }
      if (this.mainProject) {
        active++;
      }
      if (this.project) {
        active = 3;
      }
      return {
        total: 3,
        active,
        icon: active === 3 ? "check" : "close",
        variant: active === 3 ? "success" : "danger",
      };
    },
    sectionRefrigerant() {
      let active = 0;
      if (this.refrigerant) {
        active++;
      }
      if (this.form.superheat) {
        active++;
      }
      if (this.form.subcooling) {
        active++;
      }
      return {
        total: 3,
        active,
        icon: active === 3 ? "check" : "close",
        variant: active === 3 ? "success" : "danger",
      };
    },
    sectionEquipments() {
      let active = 0;
      if (this.evaporator) {
        active++;
      }
      if (this.condenser) {
        active++;
      }
      if (this.compressorBrand) {
        active++;
      }
      if (this.compressorRefrigerant) {
        active++;
      }
      if (this.compressorRefrigerantModel) {
        active++;
      }
      if (this.compressorQuantity) {
        active++;
      }
      if (this.evaporatorQuantity) {
        active++;
      }
      if (this.condenserQuantity) {
        active++;
      }
      return {
        total: 8,
        active,
        icon: active === 8 ? "check" : "close",
        variant: active === 8 ? "success" : "danger",
      };
    },
    sectionAirSideFeatures() {
      let active = 0;
      if (this.form.condensingTemp) {
        active++;
      }
      if (this.form.condenserFanFlow) {
        active++;
      }
      if (this.form.condenserAirInletTemp) {
        active++;
      }
      if (this.form.condenserAirInletHumidity) {
        active++;
      }
      if (this.form.evaporatorFanFlow) {
        active++;
      }
      if (this.form.evaporatorAirInletTemp) {
        active++;
      }
      if (this.form.evaporatorAirInletHumidity) {
        active++;
      }
      return {
        total: 7,
        active,
        icon: active === 7 ? "check" : "close",
        variant: active === 7 ? "success" : "danger",
      };
    },
  },
  methods: {
    getForm() {
      return this.setForm();
    },
    updateFlowRate(key, event) {
      const value = event.target.checked;
      console.log(key, value, "updateFlowRate");
      this.form[key] = value;
      if (value && key === "constantAirFlowRate") {
        this.form.variableAirFlowRate = false;
      } else if (value && key === "variableAirFlowRate") {
        this.form.constantAirFlowRate = false;
      }
    },
    setForm() {
      if (!this.validation()) return false;
      this.alertBox.status = false;
      return {
        refrigerantId: this.refrigerant.id,
        superheat: this.form.superheat,
        subcooling: this.form.subcooling,
        condensingTemp: this.form.condensingTemp,
        condenserFanFlow: this.form.condenserFanFlow,
        condenserAirInletTemp: this.form.condenserAirInletTemp,
        condenserAirInletHumidity: this.form.condenserAirInletHumidity,
        evaporatorAirInletTemp: this.form.evaporatorAirInletTemp,
        evaporatorAirInletHumidity: this.form.evaporatorAirInletHumidity,
        evaporatorFanFlow: this.form.evaporatorFanFlow,
        evapBatteryId: this.evaporator.id,
        condBatteryId: this.condenser.id,
        evapQuantity: this.evaporatorQuantity.label,
        condQuantity: this.condenserQuantity.label,
        compressorBrandId: this.compressorBrand.id,
        compressorRefrigerantId: this.compressorRefrigerant.id,
        compRefrigetantModelId: this.compressorRefrigerantModel.id,
        compressorQuantity: this.compressorQuantity.label,
        constantAirFlowRate: this.form.constantAirFlowRate,
        variableAirFlowRate: this.form.variableAirFlowRate,
        evapAbsoluteFlowDifference:
          this.mutlakDebi.evapAbsoluteFlowDifference || 1,
        condAbsoluteFlowDifference:
          this.mutlakDebi.condAbsoluteFlowDifference || 1,
        mutlakDebi: this.mutlakDebi,
        model: this.project.model,
      };
    },
    async getResult(e, loading) {
      const valid = this.validation();
      console.log(valid, "valid");
      if (!valid) return;
      loading(true);
      this.$store.dispatch("SET_ACTION_MODAL", {
        isLoading: true,
        status: true,
        message: this.$t("cyclesForm.calculating"),
        duration: 250 * 1000,
      });
      const form = this.setForm();
      const response = await Requests.Cycle.CalculateCycle(form);
      if (response.message === "OK") {
        if (response.data === null) {
          this.showAlertBox(this.$t("cyclesForm.calculateError"));
          this.$store.dispatch("SET_ACTION_MODAL", {
            isLoading: false,
            status: true,
            message: this.$t("cyclesForm.calculateError"),
            variant: "danger",
            duration: 5 * 1000,
          });
          loading(false);
          return;
        }
        if (response.data?.evap_mutlak_debi)
          this.mutlakDebi.evapAbsoluteFlowDifference =
            response.data.evap_mutlak_debi;
        if (response.data?.cond_mutlak_debi)
          this.mutlakDebi.condAbsoluteFlowDifference =
            response.data.cond_mutlak_debi;
        this.$emit("get:result", {
          ...response.data,
          status: true,
          form: {
            ...form,
            mutlakDebi: this.mutlakDebi,
            projectId: this.project?.id || null,
          },
        });

        if (response.data?.condFanAirFlow)
          this.form.condenserFanFlow = response.data.condFanAirFlow;
        setTimeout(() => {
          document
            .getElementById("to-result")
            .scrollIntoView({ behavior: "smooth", block: "start" });
        }, 1000);
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: false,
        });
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: response.exceptionMessage,
          variant: "danger",
          duration: 5 * 1000,
        });
        this.showAlertBox(response.exceptionMessage);
      }
      loading(false);
    },
    showAlertBox(text, variant = "danger") {
      this.alertBox = {
        status: true,
        variant: variant,
        text: text,
      };
      document
        .getElementById("page-start")
        .scrollIntoView({ behavior: "smooth", block: "start" });
    },
    validation() {
      if (
        this.sectionSeries.variant === "success" &&
        this.sectionRefrigerant.variant === "success" &&
        this.sectionEquipments.variant === "success" &&
        this.sectionAirSideFeatures.variant === "success"
      ) {
        this.validActivated = false;
        return true;
      } else {
        this.validActivated = true;
        return false;
      }
    },
    async updateSectionsAfterUpdateProject(value) {
      this.compressorBrand = value.compressorBrandInfo;
      this.compressorRefrigerant = value.compressorBrandRefrigerantInfo;
      this.compressorRefrigerantModel = value.compressorRefrigerantModelInfo;
      this.compressorQuantity = { label: value.compressorCount };
      this.refrigerant = value.refrigerantInfo;
      const evaporator =
        value.batteryInfo.find(
          (battery) => battery.type === BatteryType.Evaporator
        ) || null;
      const condenser =
        value.batteryInfo.find(
          (battery) => battery.type === BatteryType.Condenser
        ) || null;
      if (condenser) {
        this.condenserQuantity = { label: condenser.count };
        this.form.condenserFanFlow = condenser.airflow;
        this.condenser = await this.GET_BATTERY_BY_ID(condenser.id);
      }
      if (evaporator) {
        this.evaporatorQuantity = { label: evaporator.count || 1 };
        this.form.evaporatorFanFlow = evaporator.airflow;
        this.form.superheat = evaporator.superheat;
        this.form.subcooling = evaporator.subcooling;
        this.evaporator = await this.GET_BATTERY_BY_ID(evaporator.id);
      }
    },
    toggleSection(section) {
      this.activeSections.includes(section)
        ? this.activeSections.splice(this.activeSections.indexOf(section), 1)
        : this.activeSections.push(section);
    },
    async GET_BATTERY_BY_ID(id) {
      if (!id) return null;
      const response = await this.$store.dispatch("getBatteryById", { id });
      if (response.message === "OK") {
        return response.data;
      }
      return null;
    },
    async GET_SERIES_BY_ID(id) {
      if (!id) return null;
      if (this.series?.id === id) return this.series;
      const response = await Requests.Series.GetById({ params: { id } });
      if (response.message === "OK") {
        return response.data;
      }
      return null;
    },
    async GET_MAIN_PROJECT_BY_ID(id) {
      if (!id) return null;
      if (this.mainProject?.id === id) return this.mainProject;
      const response = await Requests.MainProject.GetById({ params: { id } });
      if (response.message === "OK") {
        return response.data;
      }
      return null;
    },
    async GET_PROJECT_BY_ID(id) {
      if (!id) return null;
      if (this.project?.id === id) return this.project;
      const response = await Requests.Project.GetById({ params: { id } });
      if (response.message === "OK") {
        return response.data;
      }
      return null;
    },
    async getQuery() {
      const query = this.$route.query;
      const projectId = Number(query?.projectId || null);
      if (!isNaN(projectId) && projectId !== 0)
        this.project = await this.GET_PROJECT_BY_ID(projectId);
      if (this.project) {
        this.mainProject = this.project.mainProjectInfo || null;
        this.series = this.mainProject?.seriesInfo || null;
        this.projectMainProject = {
          mainProject: this.mainProject,
          project: this.project,
          id: this.project.id,
        };
      }
      await this.getInitCycle();
      this.pageLoaded = true;
    },
    async getInitCycle() {
      if (this.initCycle.id || (this.project?.id && !this.mainProject)) {
        this.mainProject = await this.GET_MAIN_PROJECT_BY_ID(
          this.initCycle.projectInfo?.mainProjectInfo?.id || null
        );
        this.series = this.mainProject?.seriesInfo || null;
        if (!this.project) {
          this.project = await this.GET_PROJECT_BY_ID(
            this.initCycle.projectInfo?.id || null
          );
        }
      }
      return true;
    },
  },
  async mounted() {
    await this.getQuery();
  },
};
</script>

<style></style>
